import { Divider, Stack } from "@mui/material";
import type { JSX } from "react";
import PartContainer from "./PartContainer.tsx";

interface Props {
  Parameters: JSX.Element;
  Preview: JSX.Element;
  ActionPanel: JSX.Element;
}

export default function ViewContainer({ Parameters, Preview, ActionPanel }: Props) {
  return (
    <Stack direction="row" sx={{ flex: 1, height: "100%", width: "100%" }}>
      {Parameters}
      <Divider orientation="vertical" />
      <Stack sx={{ flex: 1 }}>
        <PartContainer
          sx={{ borderRight: "unset", p: "1.3rem", pt: 2, height: "100%" }}
          containerSx={{ position: "relative", gap: "1rem" }}
          caption="Preview"
          captionVariant="subtitle2"
          actions={ActionPanel}
        >
          {Preview}
        </PartContainer>
      </Stack>
    </Stack>
  );
}
